'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormFieldValidation = exports.getStagedFormFieldValidation = exports.getFormFields = exports.getCustomFormFields = exports.getFormState = exports.getStagedFormState = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _immutable = require('immutable');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

var _EmailAddress = require('PatternValidationJS/patterns/EmailAddress');

var _EmailAddress2 = _interopRequireDefault(_EmailAddress);

var _enums = require('MeetingsBase/constants/enums');

var _utils = require('MeetingsLib/utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateEmail(email) {
  if (email && _EmailAddress2.default.test(email)) {
    return false;
  }
  return _I18n2.default.text('prebook.details.errorHelper.email');
}

function validateFirstAndLastName(fieldValue) {
  var isValid = fieldValue !== null && fieldValue !== undefined && !(0, _utils.isWhitespace)(fieldValue) && !(0, _utils.isEmpty)(fieldValue);
  if (isValid) {
    return false;
  }
  return _I18n2.default.text('prebook.details.errorHelper.required');
}

function validateCustomFormFields(customFormFields, formFields) {
  if (!formFields || !formFields.size > 0) {
    return new _immutable.Map();
  }

  var customFormFieldValidation = customFormFields.reduce(function (acc, fieldValue, fieldName) {
    var field = formFields.find(function (formField) {
      return formField.name === fieldName;
    });

    if (!field) {
      return acc.set(fieldName, false);
    }

    var hasValue = fieldValue !== null && fieldValue !== undefined;
    if (field.fieldType === _enums.FORM_FIELD_TYPES.CHECKBOX || field.fieldType === _enums.FORM_FIELD_TYPES.ENUMERATION) {
      hasValue = hasValue && fieldValue.length > 0;
    }
    if (field.type === _enums.FORM_FIELD_TYPES.TEXT) {
      hasValue = hasValue && fieldValue !== '';
    }

    if (!hasValue && field.isRequired) {
      return acc.set(fieldName, _I18n2.default.text('prebook.details.errorHelper.required'));
    }

    return acc.set(fieldName, false);
  }, (0, _immutable.Map)());

  return customFormFieldValidation;
}

var VALIDATOR_MAP = new _immutable.Map({
  email: validateEmail,
  firstName: validateFirstAndLastName,
  lastName: validateFirstAndLastName,
  customFormFields: validateCustomFormFields
});

var getStagedFormState = exports.getStagedFormState = (0, _get2.default)('stagedFormState');
var getFormState = exports.getFormState = (0, _get2.default)('formState');
var getCustomFormFields = exports.getCustomFormFields = (0, _reselect.createSelector)([getStagedFormState], function (stagedFormState) {
  return stagedFormState.customFormFields;
});

var getFormFields = exports.getFormFields = (0, _getIn2.default)(['bookInfo', 'customParams', 'formFields']);

var getValidation = function getValidation(validatorMap, formStateGetter) {
  return (0, _reselect.createSelector)([formStateGetter, getFormFields], function (formState, formFields) {
    if (!formState) {
      return false;
    }

    return validatorMap.reduce(function (validationErrors, validationFunction, fieldName) {
      var formValue = formState.get(fieldName);
      return validationErrors.set(fieldName, validationFunction(formValue, formFields));
    }, new _immutable.Map());
  });
};

var getStagedFormFieldValidation = exports.getStagedFormFieldValidation = getValidation(VALIDATOR_MAP, getStagedFormState);

var getFormFieldValidation = exports.getFormFieldValidation = getValidation(VALIDATOR_MAP, getFormState);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/FormFieldValidationSelector.js
// module id = 120
// module chunks = 0